import { TradeGroup } from "@utils/BasicTypes";

export const categoryGetOptionLabel = (option: TradeGroup) => option.groupDescription;
export const categoryIsOptionEqualToValue = (option: TradeGroup, value: TradeGroup) =>
  option.groupCode === value.groupCode;
